import React from "react";
import PropTypes from "prop-types";
import { Link } from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router-dom";

// Links from the dashboard to a vehicle's / charger's details page. They carry
// returnTo (like the Chargers card) so the details page's back button comes back
// here; real anchors, so Ctrl/Cmd-click opens a new tab. Without an id, plain text.

const useReturnTo = () => {
  const location = useLocation();
  return `${location.pathname}${location.search}`;
};

const DetailLink = ({ to, children }) => {
  const returnTo = useReturnTo();
  return (
    <Link
      component={RouterLink}
      to={to}
      state={{ returnTo }}
      underline="hover"
      sx={{ fontWeight: 600, color: "primary.main" }}
    >
      {children}
    </Link>
  );
};
DetailLink.propTypes = { to: PropTypes.string.isRequired, children: PropTypes.node };

export const VehicleLink = ({ vehicleId, children }) =>
  vehicleId == null ? <>{children}</> : <DetailLink to={`/vehicles/${vehicleId}`}>{children}</DetailLink>;
VehicleLink.propTypes = {
  vehicleId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.node,
};

export const ChargerLink = ({ chargerPk, children }) =>
  chargerPk == null ? <>{children}</> : <DetailLink to={`/charger/${chargerPk}`}>{children}</DetailLink>;
ChargerLink.propTypes = {
  chargerPk: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.node,
};
